<div class="modal-contents">

    <!-- Modal Header -->
    <div class="modal-header" [ngClass]="!header ? 'no-header' : ''">
      <div class="row" *ngIf="header">
        <div class="col-12 text-center">
          <h2><strong>{{header}}</strong></h2>
        </div>
      </div>
    </div>
  
    <!-- Modal body -->
    <div class="modal-body">
      <div class="row justify-content-center confirm-title">
        <div class="col-12" *ngIf="!config.noIcon">
            <!-- <div class="img-message" style="margin-bottom: 10px">
                <img [src]="Constant.url_asset + '/assets/images/icon/notice.png'">
              </div> -->
              <div class="f-modal-alert">
                  <div class="f-modal-icon f-modal-warning scaleWarning">
                      <span class="f-modal-body pulseWarningIns"></span>
                      <span class="f-modal-dot pulseWarningIns"></span>
                    </div>
              </div>
        </div>
        <div class="col-12 text-center">
          <h3><strong>{{title}}</strong></h3>
        </div>
       
      </div>
    </div>
    <div class="modal-footer justify-content-center" *ngIf="func">
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-6">
              <button nz-button nzType="default" (click)="cancel()">
                {{buttonCancelLabel}}</button>
            </div>
            <div class="col-lg-6">
              <button nz-button nzType="primary" (click)="argree()">
                {{buttonLabel}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>